export const ADDEVENTS = 'ADDEVENTS';
export const DELETEEVENTS = 'DELETEEVENTS';
export const RESETEVENTS = 'RESETEVENTS';
export const ID = 'ID';
export const USERAGENT = 'USERAGENT';
export const IPADDRESS = 'IPADDRESS';
export const SITEURL = 'SITEURL';
export const SITEVERSION = 'SITEVERSION';
